import React from "react";
import { theme } from "antd";
import { formatCents } from "./money";

/**
 * Renders integer cents with formatCents in tabular figures.
 *   signed  colour positive amounts with colorSuccess and negative ones with colorError
 *   strong  semibold;  large  prominent (phone card headings)
 * Formatting is formatCents unchanged; this only adds presentation.
 */
const Amount = ({ cents, signed = false, strong = false, large = false, symbol = true, style }) => {
  const { token } = theme.useToken();
  const n = Number(cents || 0);
  const color = signed
    ? n < 0
      ? token.colorError
      : n > 0
        ? token.colorSuccess
        : undefined
    : undefined;
  const cls = ["acct-num", strong || large ? "acct-num--strong" : "", large ? "acct-amount-lg" : ""]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} style={color ? { color, ...style } : style}>
      {formatCents(cents, { symbol })}
    </span>
  );
};

export default Amount;
